import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FanGlyph = /*#__PURE__*/createElement("g", {
  id: "fan"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M34.4,17.5c-7.8,0-12.6,6.2-12.6,11.7c0,5,4.6,8.1,6.7,9.4c2.7,1.6,7.3,2.3,7.3,3.4c0,1-0.5,2.4-3.1,2.4 c-2.5,0-8.2-2.2-9.6-2.2c-0.1,0-0.3,0-0.4,0c-1.6,0-5.2,0.3-5.2,7.4c0,7.8,6.2,12.6,11.7,12.6c5,0,8.1-4.6,9.4-6.7 c1.6-2.6,2.3-7.3,3.4-7.3c1,0,2.4,0.5,2.4,3.1c0,2.5-2.2,8.2-2.2,9.6c0,1.3-0.4,5.6,7.4,5.6c7.8,0,12.6-6.2,12.6-11.7 c0-5-4.6-8.1-6.7-9.4c-2.6-1.6-7.3-2.3-7.3-3.4c0-1,0.5-2.4,3.1-2.4c2.5,0,8.2,2.2,9.6,2.2c0.1,0,0.3,0,0.4,0 c1.6,0,5.2-0.3,5.2-7.4c0-7.8-6.2-12.6-11.7-12.6c-5,0-8.1,4.6-9.4,6.7c-1.6,2.6-2.3,7.3-3.4,7.3c-1,0-2.4-0.5-2.4-3.1 c0-2.5,2.2-8.2,2.2-9.6C41.8,21.8,42.2,17.5,34.4,17.5L34.4,17.5z"
})));
const Fan = createSvg({
  name: 'fan',
  path: FanGlyph
});

export default Fan;
export { FanGlyph };
